enum Browser {
    OPERA = 'Opera',
    EDGE = 'Edge',
    FIREFOX = 'Firefox',
    SAFARI = 'Safari',
    CHROME = 'Chrome',
}

export default Browser;